import { CANINE } from 'constants/prescriptionConstants';
import {
  SAGITTAL_ACTIONS_VALUES,
  SAGITTAL_RELATIONSHIP_VALUES
} from 'constants/prescriptionOptions';

import { getStringValue, UltraFormData } from './ultraPrescription.shared';

export const getSagittalRelationshipData = (
  data: UltraFormData,
  isLeft: boolean
) => {
  const sagittalRelationship =
    data?.treatmentSpecifications?.sagittalRelationship;

  const isRandL =
    sagittalRelationship?.relationship ===
    SAGITTAL_RELATIONSHIP_VALUES?.RIGHT_AND_LEFT;

  const action = isRandL
    ? sagittalRelationship?.bothRandL?.rightAndLeftAction
    : isLeft
    ? sagittalRelationship?.eitherRorL?.left?.leftAction
    : sagittalRelationship?.eitherRorL?.right?.rightAction;

  const subOptions = isRandL
    ? sagittalRelationship?.bothRandL
    : isLeft
    ? sagittalRelationship?.eitherRorL?.left
    : sagittalRelationship?.eitherRorL?.right;

  const isCanineSelected = action?.find(
    (item) =>
      item?.value === SAGITTAL_ACTIONS_VALUES.IMPROVE_CANINE_RELATIONSHIP
  );
  const isMolarSelected = action?.find(
    (item) => item?.value === SAGITTAL_ACTIONS_VALUES.IMPROVE_MOLAR_RELATIONSHIP
  );
  const isAfterAlignmentSelected = action?.find(
    (item) =>
      item?.value === SAGITTAL_ACTIONS_VALUES.SHOW_RESULTING_AFTER_ALIGNMENT
  );

  return {
    value: action?.map((item) => item?.value),
    ...(isCanineSelected && {
      improveCanineRelationshipOptions: {
        value: subOptions?.improveCanine?.canine,
        treatmentOptions: {
          freeText: subOptions?.improveCanine?.text,
          ipr: subOptions?.improveCanine?.improveSubOptions?.ipr,
          classElastic: subOptions?.improveCanine?.improveSubOptions?.elastic,
          canineDistalization:
            subOptions?.improveCanine?.improveSubOptions?.canineDistalization,
          associatedElastic:
            subOptions?.improveCanine?.improveSubOptions?.associatedElastic,
          canineMesialization:
            subOptions?.improveCanine?.improveSubOptions?.canineMesialization
        }
      }
    }),
    ...(isMolarSelected && {
      improveMolarRelationship: {
        value: subOptions?.improveMolar?.molar,
        treatmentOptions: {
          freeText: subOptions?.improveMolar?.text,
          ipr: subOptions?.improveMolar?.improveSubOptions?.ipr,
          classElastic: subOptions?.improveMolar?.improveSubOptions?.elastic,
          molarDistalization:
            subOptions?.improveMolar?.improveSubOptions?.molarDistalization,
          associatedElastic:
            subOptions?.improveMolar?.improveSubOptions?.associatedElastic,
          molarMesialization:
            subOptions?.improveMolar?.improveSubOptions?.molarMesialization
        }
      }
    }),
    ...(isAfterAlignmentSelected && {
      showResultingAfterAlignment: {
        value: subOptions?.afterAlignment?.text
      }
    })
  };
};

export const getSagittalTreatmentOptions = (
  improvementType: string,
  tpv?: Record<string, unknown>,
  fieldName?: string
) => {
  const distalizationFieldName =
    improvementType === CANINE ? 'canineDistalization' : 'molarDistalization';
  const mesializationFieldName =
    improvementType === CANINE ? 'canineMesialization' : 'molarMesialization';
  return {
    text: getStringValue(tpv, `${fieldName}.freeText`),
    improveSubOptions: {
      associatedElastic: getStringValue(tpv, `${fieldName}.associatedElastic`),
      ipr: getStringValue(tpv, `${fieldName}.ipr`),
      elastic: getStringValue(tpv, `${fieldName}.classElastic`),
      [distalizationFieldName]: getStringValue(
        tpv,
        `${fieldName}.${distalizationFieldName}`
      ),
      [mesializationFieldName]: getStringValue(
        tpv,
        `${fieldName}.${mesializationFieldName}`
      )
    }
  };
};
